import { createRoot } from 'react-dom/client';
import { ScreenClassProvider } from '@vp/swan';
import { LocalizationProvider } from '@vp/om-translations';
import { TaxIdEntryMain } from './components/TaxIdEntryMain';
import translationResources from '../assets/i18n';
import { SwanConfiguration } from './components/SwanConfiguration';

// https://react.dev/blog/2022/03/08/react-18-upgrade-guide#updates-to-client-rendering-apis
// Move to root.render() from ReactDOM.render() for React 18 upgrade.
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <SwanConfiguration>
    <LocalizationProvider
      translationResources={translationResources}
      locale={
        new URLSearchParams(window?.location?.search).get('locale') || 'en-US'
      }
      logLevel="ERROR"
    >
      <ScreenClassProvider>
        <TaxIdEntryMain />
      </ScreenClassProvider>
    </LocalizationProvider>
  </SwanConfiguration>
);
